import BackButtonToolbar from "features/BackButtonToolbar";
import InactiveDeleteOptionEditToolbar from "features/EditToolbar";
import React from "react";
import { Edit, SimpleForm, useNotify, useStore } from "react-admin";
import SaveForm from "./SaveForm";
import useConflictErrorModal from "server/components/Modals/useConflictErrorModal";
import { errorMessages } from "app";

const STORE_KEY = "internshipCyclesSchedule.filters";

const EditScheduleCycleStream = () => {
  const [filters] = useStore(STORE_KEY, null);
  const { handleConflictError, ConflictErrorDialog } = useConflictErrorModal();
  const notify = useNotify();

  const transform = data => ({
    internshipSessionId: data.internshipSessionId,
    planId: data.planId,
    name: data.name,
    studyGroups: data.studyGroups,
    cycles: data.cycles?.map(cycle => ({
      id: cycle.id,
      disciplineId: cycle.disciplineId,
      fromDate: cycle.fromDate,
      toDate: cycle.toDate,
      employees: cycle.employees?.map(emp => ({
        id: emp.id,
        employeeId: emp.employeeId,
        roomId: emp.roomId,
        buildingId: emp.buildingId,
        studyGroups: emp.studyGroups,
      })),
    })),
  });

  return (
    <>
      <Edit
        title="Редакция на поток за преддипломен стаж"
        actions={<BackButtonToolbar />}
        transform={transform}
        mutationMode="pessimistic"
        mutationOptions={{
          onError: e => {
            handleConflictError(e);
            const errorMessage = e.message || errorMessages[e.errorCode];
            notify(errorMessage, { type: "error" });
          },
        }}
      >
        <SimpleForm
          toolbar={<InactiveDeleteOptionEditToolbar />}
          defaultValues={{
            academicYearId: filters?.academicYearId,
            structuralUnitId: filters?.structuralUnitId,
            internshipSessionId: filters?.internshipSessionId,
            planId: filters?.planId,
          }}
        >
          <SaveForm filters={filters} />
        </SimpleForm>
      </Edit>
      <ConflictErrorDialog />
    </>
  );
};

export default EditScheduleCycleStream;
